import styled from "styled-components";
import { devices } from "../ExternFormEnrollment/ExternFormEnrollment.styles";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  height: 50vh;
`;

export const Header = styled.div`
  width: 100%;
  padding: 36px;
  border-radius: 16px;
  background-color: #f6f1ee;
  color: #4f4a45;
`;

export const HeaderTitle = styled.h2`
  padding-bottom: 1rem;
  font-size: 2rem;
  color: #4f4a45;
  text-transform: initial;
`;

export const HeaderMobilepay = styled.div`
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  margin-bottom: 20px;
  
  @media (min-width: 500px) {
    display: flex;
    align-items: center;
    margin: 30px 0;
  }
`;

export const MobilepayImg = styled.img`
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    float: left; 
    width: 50px;
    margin-right: 20px;
  }
`;

export const LotteryImg = styled.img`
  width: auto; 
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;

  @media (min-width: 500px) {
    float: left; 
    width: 50px;
    margin-right: 20px;
  }
`;

export const ErrorTitle = styled.h2`
  padding-bottom: 1rem;
  font-size: 1.2rem;
  color: var(--color-error);
  text-transform: initial;
  text-align: center;
`;

export const HeaderSubtitle = styled.p``;

export const HeaderSubtitleMP = styled.p`
  margin-bottom: 0px;
`;

export const TraceWrapper = styled.div`
  width: 100%;
  padding: 50px 40px;
`;

//Lottery Content 
export const ContentWrapper = styled.div`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  @media ${devices.tablet} {
    width: 70%;
  }
  @media ${devices.laptop} {
    max-width: 60%;
  }
  @media ${devices.laptopLdesktop} {
    width: 40%;
  }
`;

export const CTA = styled.a`
  margin-top: 16px;
`;

export const LotteryContainer = styled.div`
  border-radius: 8px;
  background-color: rgb(255, 255, 255);
  border-left: 1px solid rgb(233, 233, 233);
  border-right: 1px solid rgb(233, 233, 233);
  border-bottom: 1px solid rgb(233, 233, 233);
  margin-top: 20px;
  display: flex;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${devices.tablet} {
    flex-direction: row;
  }
`;

export const LotteryImgContainer = styled.div`
`;

export const LotteryIcon = styled.img`
  padding-right: 12px;
  width: 100px;
  @media ${devices.tablet} {
    width: auto;
  }
`;

export const Heighlight = styled.p`
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 4px;
  @media ${devices.tablet} {
    font-size: 1.1em;
  }
`;

export const Gift = styled.span`
    font-size: 37px;
    padding-bottom: 10px; 
`;